import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 16.876 12.376"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.313 0a.567.567 0 0 0-.563.563v1.125H1.126A1.125 1.125 0 0 0 0 2.813v6.75a1.123 1.123 0 0 0 1.126 1.125H6.75v1.125a.567.567 0 0 0 .563.563.567.567 0 0 0 .563-.563V.563A.567.567 0 0 0 7.313 0M1.126 9.563v-6.75H6.75v6.75zm15.75-6.75v6.75a1.123 1.123 0 0 1-1.126 1.125H9.563a.562.562 0 1 1 0-1.125h6.187v-6.75H9.563a.562.562 0 1 1 0-1.125h6.187a1.125 1.125 0 0 1 1.126 1.125m-11.25 2.25a.567.567 0 0 1-.563.563H4.5v1.687a.566.566 0 0 1-.562.563.566.566 0 0 1-.562-.563V5.626h-.563a.567.567 0 0 1-.563-.563.567.567 0 0 1 .563-.563h2.25a.567.567 0 0 1 .563.563"
    }, null, -1)
  ])))
}
export default { render: render }